
import router from "@/router";
import { Vue, Options } from "vue-class-component";
import { Watch, Prop } from "vue-property-decorator";
export default class View403 extends Vue {
  timer = 3;
  created() {
    this.count();
  }

  count() {
    if (this.timer == 0 && router.currentRoute.value.path == "/403") {
      router.push("/");
    } else {
      setTimeout(() => {
        this.timer--;
        this.count();
      }, 1000);
    }
  }
}
